<template>
    <div class="main" style="margin-bottom:50px;">
        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <div @click="redirectPreviousUrl"
                    style="font-size:20px;text-decoration: none;width:30%;line-height:30px;display:flex;cursor:pointer">
                    <p>
                        <a-icon style="font-size: 15px; margin-right: 8px;" type="arrow-left" />
                    </p>
                    <p>Go Back To Shipment </p>
                </div>
                <div>
                    <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="edit" class="mr-4">
                        Edit
                    </a-button>
                    <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div>
            </div>
            <div id="printMe" style="margin-top:50px; padding:30px;">
                <a-card :loading="loading" style="border-radius: 7px;" :bordered="true">
                    <div class="container">
                        <!-- Content here -->
                        <div class="row">
                            <div style="display: flex; flex-direction: column;" class="col">
                                <span style="font-size:48px; color: #000000; font-weight:bolder">Shipment Order</span>
                                <span style="font-size: 15px; color: #4D4D4D">Shipment Order# - S-454356</span>
                                <span class="mt-5">
                                    <status-component :status="statusLabel"></status-component>
                                </span>

                            </div>

                        </div>
                        <div class="row  mt-5">
                            <div class="col-9">
                                <div>
                                    <p>Order Date</p>
                                    <p>14-04-2024</p>
                                </div>
                            </div>
                            <div class="col-3">
                                <div>
                                    <div style="padding-bottom: 10px">
                                        <span style="font-weight:bolder;font-size:16px;display:block">
                                            Ship To
                                        </span>
                                        <span style="font-weight:bolder;font-size:16px; color: #26A246">
                                            Cowtribe
                                        </span>
                                    </div>

                                    <div style="padding-bottom: 10px">
                                        <span style="font-size:16px;display:block;">
                                            Address
                                        </span>
                                        <span style="font-size:16px;display:block">
                                            Adestoo Street A43/7
                                            <br />
                                            Laterbiokorshie - Accra
                                        </span>
                                    </div>

                                    <div>
                                        <span style="font-size:16px;display:block">
                                            Phone Number
                                        </span>
                                        <span style="font-size:16px;display:block">
                                            233549216968
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- <div class="row" style="margin-top:30px;display: flex; justify-content: space-between">
                    <div class="col">
                        <div style="font-weight:bolder">Shipping Method</div>
                        <div style="padding-left: 38px;padding-right: 38px;">{{ shippingMethodLabel }}</div>
                    </div>
                    
                    <div class="col" style="text-align: end;" :span="12">
                        <div style="font-weight:bolder">Delivery Date</div>
                        <div style="">
                            {{ deliveryDate }}
                        </div>
                    </div>
                </div> -->
                        <div class="mt-5">
                            <table class="table table-hover">
                                <thead style="background-color: #26A246; color: #fff;">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Product</th>
                                        <th scope="col">Sales Order#</th>
                                        <th scope="col">Order Date</th>
                                        <th scope="col">Carrier</th>
                                        <th scope="col">Tracking</th>
                                        <th scope="col">Total Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="product in tableData" :key="product.id">
                                        <td>{{ product.id }}</td>
                                        <td>{{ product.productName }}</td>
                                        <td>{{ product.saleOrder }}</td>
                                        <td>{{ product.orderDate }}</td>
                                        <td>{{ product.carrier }}</td>
                                        <td>{{ product.tracking }}</td>
                                        <td>{{ product.quantity }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </a-card>

            </div>
        </a-card>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import StatusComponent from '../shared-components/StatusComponent.vue'
import { NotificationMixins } from '@/mixins/NotificationMixins'
// import { IsJsonString } from '@/utils/index'

const columns = [
    {
        title: 'Product Name',
        dataIndex: 'productName',
        key: "productName",
        // scopedSlots: { customRender: 'name' },
        width: 200,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     // scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 200,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity",
        // scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Unit Price',
        dataIndex: 'price',
        key: "price",
        // scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    {
        title: 'Line Total',
        dataIndex: 'lineTotal',
        key: "lineTotal"
        // width: 200,
    },

]

const tableData = [
    {
        id: 1,
        key: 1,
        productName: "Aliseryl",
        saleOrder: 'SO-643678',
        orderDate: '12-09-2024',
        carrier: 'Zipline',
        tracking: 'T-87765',
        quantity: 23,
    },

]



export default {
    name: "ShimentDetails",
    mixins: [NotificationMixins],
    components: {
        StatusComponent,
    },
    data() {
        return {
            columns,
            tableData,
            tableLoading: false,
            loading: false,
            addProductVisible: false,
            discount: 0,
            deliveryDate: null,
            supplierId: "",
            sellerName: "",
            sellerAddress: "",
            sellerCity: "",
            sellerCountry: "",
            customerName: "",
            customerAddress: "",
            customerCity: "",
            customerCountry: "",
            customerPhoneNumber: "",
            statusLabel: "",
            dueDate: "",
            orderId: "",
            orderType: "",
            terms: "",
            invoiceId: "",
            allowedPayment: [0, 1, 2, 3, 4, 5, 6],
            deliveriestableData: [],
            paymentModalVisible: false,
            pagination: {
                pageSize: 20
            },
            showPayemntAmount: false,
            paymentModel: {
                orderType: "",
                issuer: "",
                paymentAccount: "",
                amount: "",
                reference: ""
            },
            invoiceData: {
                sellerName: "",
                sellerAddress: "",
                sellerCity: "",
                sellerCountry: "",
                retailerName: '',
                retailerAddress: '',
                retailerCity: '',
                retailerCountry: '',
                dueDate: '',
                terms: "",
                cowtribeDate: '',
                invoiceId: '',
                reference: '',
                phoneNumber: '',
                total: '',
                products: [],
            },
            data: {},
            rules: {

                issuer: [
                    {
                        required: true,
                        message: "Please select your option",
                        trigger: "change",
                    },
                ],
                paymentAccount: [
                    {
                        required: true,
                        message: "Please enter payment amount",
                        trigger: "change",
                    },
                ],
                amount: [
                    {
                        required: true,
                        message: "Please enter amount",
                        trigger: "change",
                    },
                ],
            }
        };
    },
    computed: {
        ...mapGetters(['getInvoiceInfo']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.price && item.quantity) {
                    return parseFloat(item.price) * item.quantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)
        },

        getPurchaseOrderIder() {
            return this.purchaseOrderId ? `Order #PO-${this.purchaseOrderId}` : ""
        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        },

        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount).toFixed(2)
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'generatePurcharseOrder', 'setWareHouseDeliveryLinesInfo']),
        redirectPreviousUrl() {
            this.$router.back()
            // this.$router.push('/purchase-order-history').catch(()=>{});
        },
        handleAddProductCancel() {
            this.addProductVisible = false
        },
        showReceipt(payment) {

            const { amtInKsh, amtInGhp } = this.getIntegerDecimal(payment.totalCost.toFixed(2));
            const receipt = {
                amount: payment.totalCost,
                receivedFrom: this.data.sellerName,
                receivedBy: this.data.customerName,
                invoiceNumber: this.data.id,
                invoiceDate: moment(this.data.createdAt).format("DD-MM-YYYY"),
                paymentDate: moment(payment.createdAt).format("DD-MM-YYYY"),
                amtInKsh,
                amtInGhp,
                paymentMethod: payment.paymentType ? payment.paymentType : 'N/A'
            }

            this.$refs.invoiceReceiptRef.showReceiptData(receipt);
        },

        downloadReceipt(payment) {
            const { amtInKsh, amtInGhp } = this.getIntegerDecimal(payment.totalCost.toFixed(2));
            const receipt = {
                amount: payment.totalCost,
                receivedFrom: this.data.sellerName,
                receivedBy: this.data.customerName,
                invoiceNumber: this.data.id,
                invoiceDate: moment(this.data.createdAt).format("DD-MM-YYYY"),
                paymentDate: moment(payment.createdAt).format("DD-MM-YYYY"),
                amtInKsh,
                amtInGhp,
                paymentMethod: payment.paymentType ? payment.paymentType : 'N/A'
            }
            this.$refs.invoiceDownloadReceiptRef.downloadReceiptData(receipt);
        },

        getIntegerDecimal(value) {
            let amtInKsh = this.isInteger(value) ? value : parseInt(value.toString().split(".")[0])
            let amtInGhp = this.isInteger(value) ? 0 : parseInt(value.toString().split(".")[1])
            return {
                amtInKsh,
                amtInGhp
            }
        },

        isInteger(n) {
            return n === +n && n === (n | 0);
        },

        downloadInvoice() {
            this.invoiceData.sellerName = this.data.sellerName
            this.invoiceData.sellerAddress = this.data.sellerAddress
            this.invoiceData.sellerCity = this.data.sellerCity
            this.invoiceData.sellerCountry = this.data.sellerCountry

            this.invoiceData.retailerName = this.data.customerName
            this.invoiceData.retailerAddress = this.data.customerAddress
            this.invoiceData.retailerCity = this.data.customerCity
            this.invoiceData.retailerCountry = this.data.customerCountry

            this.invoiceData.phoneNumber = this.data.customerPhoneNumber

            this.invoiceData.terms = this.data.terms

            this.invoiceData.dueDate = moment(this.data.dueDate).format("DD-MM-YYYY")
            this.invoiceData.cowtribeDate = moment(this.data.createdAt).format("DD-MM-YYYY")
            this.invoiceData.invoiceId = this.data.id
            this.invoiceData.reference = null
            this.invoiceData.products = this.data.invoiceLines.map(product => ({
                id: product.id,
                productName: product.productName,
                quantity: product.quantity,
                unitPrice: product.price,
                lineTotal: parseInt(product.quantity) * parseFloat(product.price)
            }))

            this.invoiceData.total = this.getProductsTotalAmount(this.invoiceData.products)
            this.$refs.invoiceDownloadRef.downloadInvoice(this.invoiceData);
        },
        getProductsTotalAmount(products) {
            // console.log("in tableData |", this.tableData)
            const itemAmount = products.map(item => {
                if (item.unitPrice && item.quantity) {
                    return parseFloat(item.unitPrice) * item.quantity
                } else {
                    return 0.00
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt)
        },
        onChangeIssuer(value) {
            if (this.allowedPayment.includes(parseInt(value))) {
                this.showPayemntAmount = true
            } else {
                this.showPayemntAmount = false
            }
        },
        showPaymentModal() {
            this.paymentModalVisible = true
        },
        handlePaymentVisibleCancel() {
            this.paymentModalVisible = false
        },
        showRecordPaymentActions(statusLabel) {
            const allowedStatus = ['Pending', 'PartiallyPaid']
            const result = allowedStatus.includes(statusLabel) ? true : false
            return result
        },
        showEmailActions(statusLabel) {
            const allowedStatus = ['Draft']
            const result = allowedStatus.includes(statusLabel) ? true : false
            return result
        },

        showDeliveryLines(data) {
            this.setWareHouseDeliveryLinesInfo(data)
            this.$router.push({
                name: 'warehouse-details-lines',
                params: { locationId: data.id }
            }).catch(() => { })
        },


        submitReceipt() {
            this.$htmlToPaper('printMe');
        },
    },
    created() {
        if (this.getInvoiceInfo) {

            let result = JSON.parse(this.getInvoiceInfo)

            this.data = result
            this.invoiceId = result.id
            this.sellerName = result.sellerName
            this.sellerAddress = result.sellerAddress
            this.sellerCity = result.sellerCity
            this.sellerCountry = result.sellerCountry
            this.customerName = result.customerName
            this.statusLabel = result.invoiceStatusTypeLabel
            this.customerAddress = result.customerAddress
            this.customerPhoneNumber = result.customerPhoneNumber
            this.customerCity = result.customerCity
            this.customerCountry = result.customerCountry
            this.createdAt = result.createdAt ? moment(result.createdAt).format("DD-MM-YYYY") : 'N/A'
            this.terms = result.terms,
                this.discount = result.discount
            this.orderId = result.orderId
            this.orderType = result.orderType
            this.dueDate = moment(result.dueDate).format('DD-MM-YYYY')
            // this.tableData = result.invoiceLines.map(invoice => ({
            //     id: invoice.id,
            //     productId: invoice.productId,
            //     productName: invoice.productName,
            //     quantity: invoice.quantity,
            //     price: invoice.price,
            //     lineTotal: (parseInt(invoice.quantity) * parseFloat(invoice.price)).toFixed(2)
            // }))

            // this.payments = result.payments.map(payment => ({
            //     key: payment.id,
            //     id: payment.id,
            //     orderTypeLabel: payment.orderTypeLabel,
            //     primaryCost: payment.primaryCost,
            //     otherCost: payment.otherCost,
            //     totalCost: payment.totalCost,
            //     paymentMethod: payment.paymentMethod,
            //     createdAt: moment(payment.createdAt).format('DD-MM-YYYY HH:mm:ss'),
            //     action: payment
            // }))
        }

    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

a {
    text-decoration: none;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}


.orderTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.orderTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

@media print {
    @page {
        size: landscape
    }
}
</style>